module.exports = __webpack_public_path__ + "static/media/book-texture.6a22510b.jpg";